<div class="d-flex flex-column h-100" [class.expanded]="!layout.isCollapsed()">
  <div
    [ngClass]="layout.isCollapsed() ? 'flex-column-reverse' : 'flex-row'"
    class="d-flex align-items-center mt-1"
  >
    @if (canUseAppSwitcher()) {
      <div class="flex-grow-1" [ngClass]="layout.isCollapsed() ? 'mt-2' : 'ms-1'">
        <cds-app-switcher
          [orgName]="this.userState.org()?.name ?? ''"
          [userName]="this.userState.user()?.name ?? ''"
          [currentApp]="CopadoAppId.CRT"
          [orgId]="this.userState.org()?.id"
        >
        </cds-app-switcher>
      </div>
    }
    <div>
      <a class="navbar-brand" routerLink="/" queryParamsHandling="">
        <div
          [ngClass]="!layout.isCollapsed() ? 'mx-2' : 'condensed'"
          class="d-block"
          id="home-menu-img"
          role="img"
        ></div>
      </a>
    </div>
  </div>
  <hr class="my-3 text-secondary" />

  <app-switcher
    id="project-select"
    class="mb-2"
    [isCollapsed]="layout.isCollapsed()"
    [avatar]="initials()"
    [title]="projectState.project()?.name ?? 'Select Project'"
    [subTitle]="orgName()"
    empty="No Projects"
    minWidth="250px"
    i18n-empty
    [items]="filteredProjects()"
    [itemTemplate]="projectItem"
    (open)="open($event)"
    (select)="switchToProject($event)"
  >
    @if (orgState.projects().length > 5 && projectSwitcherOpen()) {
      <div header>
        <div class="dropdown-item-text">
          <cds-search-input
            placeholder="Search for a Project"
            [formControl]="search"
            [autofocus]="true"
            i18n-placeholder
          ></cds-search-input>
        </div>
      </div>
    }
    <div footer>
      <div class="dropdown-divider"></div>
      <div class="d-flex">
        @if (userState.role()?.canEditProjects) {
          <a
            [queryParams]="{
              modal: Modal.NewProject,
            }"
            [routerLink]="[]"
            queryParamsHandling=""
            class="dropdown-item border-end link-primary fw-semibold text-align-center text-center flex-grow-1"
          >
            <cds-icon size="small" shape="MathAndFinancePlus"></cds-icon
            ><span i18n class="ms-1">Create New</span></a
          >
        }
        <a
          [routerLink]="['projects']"
          queryParamsHandling=""
          class="dropdown-item link-primary fw-semibold text-center flex-grow-1"
        >
          <cds-icon shape="OfficeAndEditingList"></cds-icon
          ><span i18n class="ms-1">View All</span></a
        >
      </div>
    </div>
  </app-switcher>
  <ng-template #projectItem let-project>
    <div class="d-flex">
      <div class="flex-grow-1 text-truncate">
        {{ project?.name }}
      </div>
      @if (project.starred) {
        <div class="yellow-star">
          <cds-icon shape="CommunicationStarSolid" />
        </div>
      }
    </div>
  </ng-template>

  <ul class="nav nav-pills flex-column">
    <li class="nav-item">
      <app-nav-item [item]="navItems()['home']" [isCollapsed]="layout.isCollapsed()"></app-nav-item>
    </li>
  </ul>

  @if (projectState.project()) {
    <ul class="nav nav-pills flex-column">
      @if (layout.hasRoboticExplorer()) {
        @if (layout.isCollapsed()) {
          <li><hr /></li>
        } @else {
          <li class="nav-item m-2 ps-2 text-secondary" i18n>EXPLORING</li>
        }
        <li>
          <app-nav-item
            [item]="navItems()['explorer']"
            [isCollapsed]="layout.isCollapsed()"
          ></app-nav-item>
        </li>
      }
      @if (layout.hasTestAuthoring()) {
        @if (layout.isCollapsed()) {
          <li><hr /></li>
        } @else {
          <li class="nav-item m-2 ps-2 text-secondary" i18n>AUTHORING</li>
        }

        <li class="nav-item">
          <app-nav-item
            [item]="navItems()['jobs']"
            [isCollapsed]="layout.isCollapsed()"
          ></app-nav-item>
        </li>

        @if (canUseDataTables()) {
          <li class="nav-item">
            <app-nav-item
              [item]="navItems()['dataTables']"
              [isCollapsed]="layout.isCollapsed()"
            ></app-nav-item>
          </li>
        }

        @if (layout.isCollapsed()) {
          <li><hr /></li>
        } @else {
          <li class="nav-item m-2 ps-2 text-secondary" i18n>EXECUTING</li>
        }

        <li class="nav-item">
          <app-nav-item
            [item]="navItems()['runs']"
            [isCollapsed]="layout.isCollapsed()"
          ></app-nav-item>
        </li>

        <li>
          <app-nav-item
            [item]="navItems()['robots']"
            [isCollapsed]="layout.isCollapsed()"
          ></app-nav-item>
        </li>
      }
    </ul>
  }
  <div class="flex-fill"></div>
  @if (projectState.project(); as project) {
    @if (layout.hasTestAuthoring() || layout.hasRoboticExplorer()) {
      <ul class="nav nav-pills flex-column">
        <li>
          <app-nav-item
            [item]="navItems()['settings']"
            [isCollapsed]="layout.isCollapsed()"
          ></app-nav-item>
        </li>
      </ul>
    }
  }
  <hr class="my-2" />
  <ul class="nav nav-pills flex-column">
    <li>
      <ng-template i18n #expandSidebarTooltip>Expand Sidebar</ng-template>
      <button
        [ngbTooltip]="layout.isCollapsed() ? expandSidebarTooltip : ''"
        class="btn btn-outline focus-ring-light w-100"
        (click)="layout.toggleSidebar$.next('switch')"
      >
        <cds-icon
          [shape]="layout.isCollapsed() ? 'ArrowsExpandSidebar' : 'ArrowsCollapseSidebar'"
          sizePx="20"
          class="text-secondary bg-white ms-1"
        />
        @if (!layout.isCollapsed()) {
          <ng-container i18n>Collapse Sidebar</ng-container>
        }
      </button>
    </li>
  </ul>
</div>
